/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Language
 */
export interface Language {
    /**
     * 
     * @type {number}
     * @memberof Language
     */
    languageId?: number;
    /**
     * 
     * @type {string}
     * @memberof Language
     */
    mongoId?: string;
    /**
     * 
     * @type {string}
     * @memberof Language
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof Language
     */
    seq?: number;
    /**
     * 
     * @type {string}
     * @memberof Language
     */
    status?: string;
}

export function LanguageFromJSON(json: any): Language {
    return LanguageFromJSONTyped(json, false);
}

export function LanguageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Language {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'languageId': !exists(json, 'languageId') ? undefined : json['languageId'],
        'mongoId': !exists(json, 'mongoId') ? undefined : json['mongoId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'seq': !exists(json, 'seq') ? undefined : json['seq'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function LanguageToJSON(value?: Language | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'languageId': value.languageId,
        'mongoId': value.mongoId,
        'name': value.name,
        'seq': value.seq,
        'status': value.status,
    };
}

